import React from 'react';
import { motion } from 'framer-motion';
import { Moon } from 'lucide-react';
export function HeroSection() {
  return <section className="min-h-screen flex flex-col items-center justify-center px-6 py-20 relative overflow-hidden" data-id="element-42">
      {/* Background ambient glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#c9956b] opacity-[0.03] blur-[120px] rounded-full pointer-events-none" data-id="element-43" />

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-3xl mx-auto text-center z-10" data-id="element-44">
        <div className="flex justify-center mb-8" data-id="element-45">
          <Moon className="w-8 h-8 text-[#c9956b] fill-[#c9956b]/20" data-id="element-46" />
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#f5efe3] leading-[1.1] mb-12 tracking-tight" data-id="element-47">
          Tu cama no es <br data-id="element-48" />
          <span className="text-[#c9956b] italic" data-id="element-49">un tribunal.</span>
        </h1>

        <div className="space-y-6 text-lg md:text-xl text-[#f0e6d3]/90 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-50">
          <p data-id="element-51">
            Te acuestas cansado. Cuerpo agotado. Ojos pesados. Y justo cuando
            debería apagarse…{' '}
            <strong className="text-[#c9956b] font-medium" data-id="element-52">
              tu mente arranca
            </strong>
            .
          </p>
          <p data-id="element-53">
            Empieza a repasar lo que no hiciste. Lo que dijiste raro. El
            pendiente que dejaste "para mañana". La conversación que todavía te
            arde. La culpa que aparece como si tuviera reloj.
          </p>
          <p className="border-l-2 border-[#c9956b]/30 pl-6 italic text-[#8b9bb4]" data-id="element-54">
            Y ahí estás, en la cama, con una sensación absurda: tu cama se
            volvió un tribunal.
          </p>
          <p data-id="element-55">
            No necesitas que te digan "relájate". No necesitas otra lista
            eterna. Ni un consejo que funciona en TikTok durante 12 segundos y
            se muere cuando estás a solas, a oscuras, con tu cabeza gritándote.
          </p>
          <p className="text-xl font-medium pt-4" data-id="element-56">
            Necesitas una sola cosa: Un{' '}
            <span className="text-[#c9956b]" data-id="element-57">cierre</span>.
          </p>
          <p className="text-sm text-[#8b9bb4] uppercase tracking-widest pt-2" data-id="element-58">
            Un ritual corto que le diga a tu sistema: "Esto se termina hoy."
          </p>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-59">
        <div className="w-[1px] h-16 bg-gradient-to-b from-[#c9956b]/50 to-transparent" data-id="element-60" />
      </motion.div>
    </section>;
}